/**
 * Small display helpers shared by the header resource meter and the
 * "Usage & Costs" settings panel.
 */

/** Consumption status bucket derived from the consumed fraction. */
export type ConsumptionStatus = 'healthy' | 'warning' | 'critical';

/**
 * Map a consumed fraction (0–1) to a status color bucket:
 * healthy below 70 %, warning from 70 %, critical from 90 % consumed.
 */
export function consumptionStatusColor(
  consumedPercent: number | null,
): ConsumptionStatus {
  if (consumedPercent === null) return 'healthy';
  if (consumedPercent >= 0.9) return 'critical';
  if (consumedPercent >= 0.7) return 'warning';
  return 'healthy';
}

/**
 * Format a consumption amount for display: integers with thousands
 * separators (matching the plan table, e.g. "14,400"), fractional values
 * with a single decimal.
 */
export function formatConsumptionAmount(value: number): string {
  if (value === Math.floor(value)) return value.toLocaleString('en-US');
  return value.toLocaleString('en-US', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });
}

/** Format a cost in cents as a currency string (e.g. "12.34 €"). */
export function formatCostCents(cents: number, currency = 'EUR'): string {
  const amount = (cents / 100).toFixed(2);
  return currency === 'EUR' ? `${amount} €` : `${amount} ${currency}`;
}
